import React from 'react';
import {
	ContentWrap,
	Css,
	Responsive,
	Shimmer,
	ShimmerPlaceholderText,
} from '@/ui';
import styled from '@emotion/styled';
import {
	ParkingWidgetContainer,
	WidgetTitle,
} from './ParkingAvailabilityWidget';
import { ShimmerStyles } from '../../../styles/Shimmer';

export default function ParkingAvailabilityWidgetShimmer() {
	return (
		<ContentWrap>
			<ParkingWidgetContainer>
				<WidgetTitle>Open Parking Spots</WidgetTitle>
				<StyledShimmer aria-label="Loading parking availability">
					<StyledShimmerParkingSpots />
					<StyledShimmerParkingSpots />
					<StyledShimmerParkingSpots />
					<StyledShimmerParkingSpots />
				</StyledShimmer>
			</ParkingWidgetContainer>
		</ContentWrap>
	);
}

const StyledShimmer = styled(Shimmer)`
	display: flex;
	justify-content: space-between;
	gap: ${Css.pxToRem(60)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		flex-direction: column;
		gap: ${Css.pxToRem(8)};
	}
`;

const StyledShimmerParkingSpots = styled(ShimmerPlaceholderText)`
	width: 224px;
	height: 34px;
	border-radius: 8px;
	background-color: ${ShimmerStyles.BackgroundColor};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		width: 100%;
	}
`;
